/**
 * Um `setInterval` que não trabalha com a aba escondida — e lê de novo na hora em que ela volta
 * (revisão geral de 30/10, `N255`).
 *
 * As releituras de minuto (a saúde, o menu, as cotas, os prazos, a autuação, os índices) são
 * para quem está olhando. Uma aba esquecida aberta por uma noite fazia centenas de pedidos
 * que ninguém lia, e todos eles pelo banco sob RLS. Ao voltar, a pessoa não espera o próximo
 * minuto para ver números de antes de ela sair: `fn` roda uma vez no retorno.
 *
 * Devolve o cancelamento, para o `return` do efeito.
 */
export function repetirComAbaVisivel(fn: () => void, ms: number): () => void {
  const id = window.setInterval(() => {
    if (!document.hidden) fn();
  }, ms);
  const voltou = () => {
    if (!document.hidden) fn();
  };
  document.addEventListener("visibilitychange", voltou);
  return () => {
    window.clearInterval(id);
    document.removeEventListener("visibilitychange", voltou);
  };
}
